import { WorkPostDto } from '../../../app/models/workpost/workPostDto';
import { WorkPostLevel } from '../../../app/models/staticData/workPostLevel';
import { addDays } from '../../../app/utils/util';

export function getLatestWorkpost(workposts: WorkPostDto[] | null | undefined): WorkPostDto | undefined {
  return workposts?.slice().sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0];
}

export function getMinimumWorkStartDate(latestWorkpost: WorkPostDto | undefined): Date | null {
  const date = latestWorkpost ? addDays(new Date(latestWorkpost.startDate), 1) : null;
  date?.setHours(0, 0, 0, 0);
  return date;
}

export function getWorkPostLevelOptions(levels: WorkPostLevel[] | null | undefined, isPracticing: boolean | null | undefined) {
  return (levels ?? []).filter(level => level.isPracticing === isPracticing)
    .map(({ id, value, code }) => ({ id, label: value, code }));
}
